<template>
  <div class="w-60" @click.stop="show = true" v-click-outside="hide">
    <label id="listbox-label" class="block text-sm font-medium text-gray-700">
      Product
      <span v-if="selectedProduct" class="text-gray-600 ml-1">(id: {{ selectedProduct.id }})</span>
    </label>
    <div class="relative mt-2">
      <button type="button" class="relative w-full bg-white border border-gray-300 rounded-md shadow-sm pl-3 pr-10 py-2 text-left cursor-default focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary sm:text-sm" aria-haspopup="listbox" aria-expanded="true" aria-labelledby="listbox-label">
        <span class="block truncate" :class="loading && 'ske'">
          {{ (selectedProduct && selectedProduct.name) ||"Product name" }}
        </span>
        <span class="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
          <svg class="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
            <path fill-rule="evenodd" d="M10 3a1 1 0 01.707.293l3 3a1 1 0 01-1.414 1.414L10 5.414 7.707 7.707a1 1 0 01-1.414-1.414l3-3A1 1 0 0110 3zm-3.707 9.293a1 1 0 011.414 0L10 14.586l2.293-2.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" clip-rule="evenodd" />
          </svg>
        </span>
      </button>

      <portal-target name="body">
        <CatalogProductFinder
          v-model="show"
          :category="category"

          @select="product => $emit('select', product)"
          @products="prods => products = prods"
        />
      </portal-target>
    </div>
  </div>
</template>

<script>

import { mapGetters } from "vuex"

import CatalogProductFinder from "./CatalogProductFinder"

export default {
  components: {
    CatalogProductFinder,
  },
  props: ['category'],
  data() {
    return {
      show: false,
      loading: false,

      products: [],
    }
  },
  methods: {
    hide() {
      this.show = false
    },
  },
  computed: {
    ...mapGetters({
      link: 'editor/fullDomainLink',
      context: 'editor/context',
    }),

    selectedProduct() {
      const context = this.context
      if (!context) return null;
      return this.products.find(product => product.id === context.productId)
    },
  },
}

</script>
